<template>
  <div class="login-inner__nav mb-4">
    <RouterLink
      class="login-inner__nav-item"
      :to="{ path: '/login', query: { CalcID: calcID } }"
    >
      <div class="login-title">Вход по учетным данным</div>
      <div class="login-hr"></div>
    </RouterLink>
    <RouterLink
      class="login-inner__nav-item active"
      :to="{ path: '/ecp', query: { CalcID: calcID } }"
    >
      <div class="login-title">Вход по ЭЦП</div>
      <div class="login-hr"></div>
    </RouterLink>
  </div>

  <div class="login-alert p-3 text-center mb-3">
    <div class="text-primary">Внимание!</div>
    <!-- <span
      >Для входа в Личный кабинет СТОУН-XXI вставьте ключ с ЭЦП и выберите
      соответствующий ему тип</span
    > -->
    <span>Вставьте ключ ЭЦП и выберите тип ключа</span>
  </div>

  <div v-if="error" class="login-alert p-3 text-center mb-3">
    <div class="text-primary">Ошибка!</div>
    <span>{{ error }}</span>
  </div>

  <div class="mb-3">
    <EcpButton
      @auth="getCertificatesObject"
      :loading="loadingLogin"
      :loginType="loginType"
    />

    <Certificates
      v-if="certificatesObject"
      :certificatesObject="certificatesObject"
      @close="() => (certificatesObject = null)"
      @getCertificat="getCertificat"
    />
  </div>
  <PrivacyPolicy />
</template>
  
<!-- <script>
import PrivacyPolicy from "./components/PrivacyPolicy.vue";

import CryptoECP from "../lib/crypto";
import EcpButton from "../components/ecp/Button.vue";
import Certificates from "../components/ecp/Certificates.vue";

export default {
  name: "Registration",
  components: {
    PrivacyPolicy,
  },
  created() {
    document.title = "Регистрация - STONE-XXI";
  },
};
</script> -->


<script setup>
import { postApi } from "@/run";

import PrivacyPolicy from "./components/PrivacyPolicy.vue";

import CryptoECP from "../../lib/crypto";
import EcpButton from "../../component/ecp/Button.vue";
import Certificates from "../../component/ecp/Certificates.vue";

import { useStore } from "vuex";
import { onMounted, ref } from "vue";

import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const calcID = route.query.CalcID;

const store = useStore();

onMounted(() => {
  document.title = "Вход по ЭЦП - STONE-XXI";
});

const loadingLogin = ref(false);
const error = ref(null);

const loginType = ref(null);

const ecpItem = ref(true);
const certificatesObject = ref(null);
const crypto = ref(null);

const getCertificatesObject = (ecpType) => {
  if (!loadingLogin.value) {
    error.value = null;
    loadingLogin.value = true;
    loginType.value = ecpType;

    const ecp =
      ecpType === "ru-token"
        ? CryptoECP.ECP_RU_TOKEN
        : ecpType === "crypto-pro"
        ? CryptoECP.ECP_CRYPTO_PRO
        : ecpType === "jakarta"
        ? CryptoECP.ECP_JAKARTA
        : null;

    crypto.value = new CryptoECP(ecp);

    crypto.value.init(
      (ecpInfo) => {
        ecpItem.value = ecpType;
        certificatesObject.value = ecpInfo;
        loadingLogin.value = false;
      },
      (initException) => {
        store.commit("main/setAuthException", initException);
        loadingLogin.value = false;
        ecpItem.value = null;
      }
    );
  }
};

const fileSign = ref(null);

const getCertificat = (item) => {
  certificatesObject.value = null;
  if (item) {
    store.commit("main/setCertificat", item);
    next(item);
  }
};

const next = (item) => {
  error.value = null;
  loadingLogin.value = true;

  postApi("/loginEcp", {
    certificat: JSON.stringify(item),
    calcID: calcID,
  })
    .then((response) => {
      if (response.error) {
        error.value = response.error;
      }

      if (response.status) {
        if (response.root && response.root.newUser) {
          store.commit("main/setNewUser", response.root.data);
          router.push("main");
        } else {
          store.commit("main/setData", response.root);
          store.commit("main/setRoot", true);

          if (route.path === "/" || route.path === "/ecp") {
            if (response.root && response.root.leasingId) {
              // router.push("new");
              return router.push({
                name: "leasings.leasing.item",
                params: { id: response.root.leasingId },
              });
            } else {
              router.push("main");
            }
          }
        }
      }

      // else {
      //   if (response.root && response.root.newUser) {
      //     store.commit("main/setNewUser", response.root.data);
      //   }
      //   // response.root && response.root.newUser && response.root.user;
      // }
    })
    .finally(() => {
      loadingLogin.value = false;
    });
};
</script>